import { ApiError } from "@airange/shared/api";
import { readRequiredAuthMemberRoleArray } from "@airange/shared/auth-member-roles";
import type { operations } from "@airange/generated-contracts/micro-lab";

type OperationResponse<
  TOperation extends { responses: Record<number, unknown> },
  TStatus extends keyof TOperation["responses"],
> = TOperation["responses"][TStatus] extends {
  content: { "application/json": infer TResponse };
}
  ? TResponse
  : never;

type BootstrapOperation =
  operations["bootstrap_auth_session_api_auth__application_key__bootstrap_post"];

export type MicroLabCurrentUser = NonNullable<OperationResponse<BootstrapOperation, 200>>;
export type MicroLabCurrentUserRoleSource = Pick<MicroLabCurrentUser, "application_roles">;
export type MicroLabCurrentUserRoleKey = MicroLabCurrentUser["application_roles"][number];
export type MicroLabDisplayUser = MicroLabCurrentUser & {
  username: string;
  full_name?: string | null;
  avatar_url?: string | null;
};

const MICRO_LAB_CURRENT_USER_ROLE_KEYS = [
  "portal_member",
  "teacher",
  "platform_manager",
] as const satisfies readonly MicroLabCurrentUserRoleKey[];

export function readMicroLabCurrentUserApplicationRoles(
  currentUser: MicroLabCurrentUserRoleSource,
  path = "current_user.application_roles",
): MicroLabCurrentUserRoleKey[] {
  return readRequiredAuthMemberRoleArray(currentUser, {
    allowedRoles: MICRO_LAB_CURRENT_USER_ROLE_KEYS,
    path,
    createError: (issue) =>
      new ApiError(500, {
        code: "micro_lab.auth.data_contract_invalid",
        message: issue.message,
      }),
  });
}

export function toMicroLabDisplayUser(user: MicroLabCurrentUser): MicroLabDisplayUser {
  return {
    ...user,
    username: user.username ?? user.user_id,
    full_name: user.display_name ?? user.username ?? user.user_id,
  };
}
